import { ComponentsOverrides } from '@mui/material';

const styleOverrides: ComponentsOverrides['MuiInputBase'] = {};

export const MuiInputBase = {
  styleOverrides,
};
